import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer className="bg-navy text-cream py-12 text-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Podporili nás Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-8"
        >
          <h3
            className="text-xl sm:text-2xl font-semibold mb-2"
            style={{ fontFamily: "Baloo 2" }}
          >
            Podporili nás
          </h3>
          <div className="flex justify-center items-center space-x-6">
          <div className="flex justify-center items-center">
            <img
              src="/Erb_zilinska_dieceza.png"
              alt="Podporili nás"
              className="w-24 h-auto object-contain transition-transform duration-300 hover:scale-105"
            />
          </div>
          <div className="flex justify-center items-center">
            <a href="https://mojkrok.dcza.sk/" target="_blank" rel="noopener noreferrer">
              <img
                src="/logo_krok.png"
                alt="Podporili nás"
                className="w-24 h-auto object-contain transition-transform duration-300 hover:scale-105"
              />
            </a>
          </div>
          </div>
        </motion.div>
{/* 
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="text-lg sm:text-xl font-medium mt-4"
          style={{ fontFamily: "Baloo 2" }}
        >
          © 2025 Webová stránka bola vytvorená spoločnosťou EcoSystems s.r.o. Všetky práva vyhradené.        
          
        </motion.p> */}
      </div>

      {/* Decorative Divider */}
      <div className="mt-8 border-t border-cream/30 w-3/4 mx-auto" />

      {/* Additional Links (Optional) */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.6 }}
        viewport={{ once: true }}
        className="mt-6 flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-sm sm:text-base"
      >
        {/* <a href="/kontakt" className="hover:text-cream/80 transition-colors">
          Kontakt
        </a>
        <a
          href="/ochrana-osobnych-udajov"
          className="hover:text-cream/80 transition-colors"
        >
          Ochrana osobných údajov
        </a>
        <a href="/podmienky" className="hover:text-cream/80 transition-colors">
          Podmienky používania
        </a> */}
      </motion.div>
    </footer>
  );
};

export default Footer;
